import React from 'react';
import { MUEmailGrey, MUWebsite, MUWhatsappGrey } from '../../../assets/hostedassets';

/** Returns undefined for null, empty, or literal "undefined" strings. */
export const validOrgId = (v?: string | null): string | undefined => (v && v !== 'undefined' ? v : undefined);

/**
 * Resolves the correct assesseeOrgId based on context.
 * In company context (isCompany or isBorrowerReq), URL is the source of truth
 * because Redux holds the partner's own org ID, not the target company's.
 */
export const resolveAssesseeOrgId = ({
    isCompany,
    isBorrowerReq,
    orgIdFromQuery,
    orgIdFromRoute,
    orgIdFromRedux,
}: {
    isCompany: boolean;
    isBorrowerReq: boolean;
    orgIdFromQuery: string | null;
    orgIdFromRoute: string | undefined;
    orgIdFromRedux: string | undefined;
}): string | undefined => {
    return isCompany || isBorrowerReq
        ? validOrgId(orgIdFromQuery) ?? validOrgId(orgIdFromRoute) ?? validOrgId(orgIdFromRedux)
        : validOrgId(orgIdFromRedux) ?? validOrgId(orgIdFromRoute);
};

export type SourceType = 'whats_app' | 'gmail' | 'app';

export const getSourceIcon = (source: SourceType) => {
    switch (source) {
        case 'whats_app':
            return <img src={MUWhatsappGrey} alt={'Whatsapp'} />;
        case 'gmail':
            return <img style={{ height: '22px' }} src={MUEmailGrey} alt={'Email'} />;
        case 'app':
            return <img src={MUWebsite} alt={'Website'} />;
        default:
            return '-';
    }
};
